import * as actionTypes from "./actions";
import * as I from "immutable";
import { Map } from "immutable";
import CoinContext from "contexts/CoinContext";
import { map_coins, map_balance } from "./constant";
import Portfolio from "./models/Portfolio";
import { OrderTicketTypes } from "./actions";
import { de } from "date-fns/locale";

// const predict_history = require("../assets/json/normalized-predict-2026-06-17.json");
// const predict_history = require("../assets/json/normalized-predict-2026-06-18.json");
// const predict_history = require("../assets/json/normalized-predict-2026-06-24.json");
// const predict_history = require("../assets/json/normalized-predict-2026-06-29.json");
// const predict_history = require("../assets/json/normalized-predict-2026-06-30.json");
const predict_history = require("../assets/json/normalized-predict-2026-07-01.json");
let map_predict_history = I.Map();

Object.keys(predict_history).forEach( (key) => {
    if (predict_history[key].result.error === "none")
    {
        map_predict_history = map_predict_history.set(predict_history[key].result.symbol, predict_history[key].result.prediction);
    }
});

// TMD console.log(map_predict_history);

const ohlcNBIS = require('../assets/json/NBIS.ohlc.json');
const predNBIS = require('../assets/json/NBIS.prediction.json');
const ohlcCRWV = require('../assets/json/CRWV.ohlc.json');
const predCRWV = require('../assets/json/CRWV.prediction.json');
const ohlcIBRX = require('../assets/json/IBRX.ohlc.json');
const predIBRX = require('../assets/json/IBRX.prediction.json');
const ohlcIONQ = require('../assets/json/IONQ.ohlc.json');
const predIONQ = require('../assets/json/IONQ.prediction.json');
const ohlcIREN = require('../assets/json/IREN.ohlc.json');
const predIREN = require('../assets/json/IREN.prediction.json');
const ohlcNUAI = require('../assets/json/NUAI.ohlc.json');
const predNUAI = require('../assets/json/NUAI.prediction.json');
const ohlcPOET = require('../assets/json/POET.ohlc.json');
const predPOET = require('../assets/json/POET.prediction.json');
const ohlcCSIQ = require('../assets/json/CSIQ.ohlc.json');
const predCSIQ = require('../assets/json/CSIQ.prediction.json');
const ohlcTSEM = require('../assets/json/TSEM.ohlc.json');
const predTSEM = require('../assets/json/TSEM.prediction.json');
const ohlcWULF = require('../assets/json/WULF.ohlc.json');
const predWULF = require('../assets/json/WULF.prediction.json');
const ohlcUSAR = require('../assets/json/USAR.ohlc.json');
const predUSAR = require('../assets/json/USAR.prediction.json');
const ohlcFCEL = require('../assets/json/FCEL.ohlc.json');
const predFCEL = require('../assets/json/FCEL.prediction.json');

let ohlcDataMap = I.Map();
let predDataMap = I.Map();


let oDataNBIS = [];
Object.keys(ohlcNBIS.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataNBIS = [...oDataNBIS, ohlcNBIS['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataNBIS.length);
// TMD console.log(oDataNBIS);

let pDataNBIS = [];
Object.keys(predNBIS.prediction).forEach((key)=> {
        pDataNBIS = [...pDataNBIS, {'time': predNBIS['prediction'][key].time, 'value': predNBIS['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataNBIS.length);
// TMD console.log(pDataNBIS);
ohlcDataMap = ohlcDataMap.set("NBIS", oDataNBIS);
predDataMap = predDataMap.set("NBIS", pDataNBIS);

let oDataCRWV = [];
Object.keys(ohlcCRWV.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataCRWV = [...oDataCRWV, ohlcCRWV['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataCRWV.length);
// TMD console.log(oDataCRWV);

let pDataCRWV = [];
Object.keys(predCRWV.prediction).forEach((key)=> {
        pDataCRWV = [...pDataCRWV, {'time': predCRWV['prediction'][key].time, 'value': predCRWV['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataCRWV.length);
// TMD console.log(pDataCRWV);
ohlcDataMap = ohlcDataMap.set("CRWV", oDataCRWV);
predDataMap = predDataMap.set("CRWV", pDataCRWV);

let oDataIBRX = [];
Object.keys(ohlcIBRX.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataIBRX = [...oDataIBRX, ohlcIBRX['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataIBRX.length);
// TMD console.log(oDataIBRX);

let pDataIBRX = [];
Object.keys(predIBRX.prediction).forEach((key)=> {
        pDataIBRX = [...pDataIBRX, {'time': predIBRX['prediction'][key].time, 'value': predIBRX['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataIBRX.length);
// TMD console.log(pDataIBRX);
ohlcDataMap = ohlcDataMap.set("IBRX", oDataIBRX);
predDataMap = predDataMap.set("IBRX", pDataIBRX);

let oDataIONQ = [];
Object.keys(ohlcIONQ.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataIONQ = [...oDataIONQ, ohlcIONQ['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataIONQ.length);
// TMD console.log(oDataIONQ);

let pDataIONQ = [];
Object.keys(predIONQ.prediction).forEach((key)=> {
        pDataIONQ = [...pDataIONQ, {'time': predIONQ['prediction'][key].time, 'value': predIONQ['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataIONQ.length);
// TMD console.log(pDataIONQ);
ohlcDataMap = ohlcDataMap.set("IONQ", oDataIONQ);
predDataMap = predDataMap.set("IONQ", pDataIONQ);

let oDataIREN = [];
Object.keys(ohlcIREN.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataIREN = [...oDataIREN, ohlcIREN['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataIREN.length);
// TMD console.log(oDataIREN);

let pDataIREN = [];
Object.keys(predIREN.prediction).forEach((key)=> {
        pDataIREN = [...pDataIREN, {'time': predIREN['prediction'][key].time, 'value': predIREN['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataIREN.length);
// TMD console.log(pDataIREN);
ohlcDataMap = ohlcDataMap.set("IREN", oDataIREN);
predDataMap = predDataMap.set("IREN", pDataIREN);

let oDataNUAI = [];
Object.keys(ohlcNUAI.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataNUAI = [...oDataNUAI, ohlcNUAI['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataNUAI.length);
// TMD console.log(oDataNUAI);

let pDataNUAI = [];
Object.keys(predNUAI.prediction).forEach((key)=> {
        pDataNUAI = [...pDataNUAI, {'time': predNUAI['prediction'][key].time, 'value': predNUAI['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataNUAI.length);
// TMD console.log(pDataNUAI);
ohlcDataMap = ohlcDataMap.set("NUAI", oDataNUAI);
predDataMap = predDataMap.set("NUAI", pDataNUAI);

let oDataPOET = [];
Object.keys(ohlcPOET.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataPOET = [...oDataPOET, ohlcPOET['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataPOET.length);
// TMD console.log(oDataPOET);

let pDataPOET = [];
Object.keys(predPOET.prediction).forEach((key)=> {
        pDataPOET = [...pDataPOET, {'time': predPOET['prediction'][key].time, 'value': predPOET['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataPOET.length);
// TMD console.log(pDataPOET);
ohlcDataMap = ohlcDataMap.set("POET", oDataPOET);
predDataMap = predDataMap.set("POET", pDataPOET);

let oDataCSIQ = [];
Object.keys(ohlcCSIQ.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataCSIQ = [...oDataCSIQ, ohlcCSIQ['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataCSIQ.length);
// TMD console.log(oDataCSIQ);

let pDataCSIQ = [];
Object.keys(predCSIQ.prediction).forEach((key)=> {
        pDataCSIQ = [...pDataCSIQ, {'time': predCSIQ['prediction'][key].time, 'value': predCSIQ['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataCSIQ.length);
// TMD console.log(pDataCSIQ);
ohlcDataMap = ohlcDataMap.set("CSIQ", oDataCSIQ);
predDataMap = predDataMap.set("CSIQ", pDataCSIQ);

let oDataTSEM = [];
Object.keys(ohlcTSEM.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataTSEM = [...oDataTSEM, ohlcTSEM['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataTSEM.length);
// TMD console.log(oDataTSEM);

let pDataTSEM = [];
Object.keys(predTSEM.prediction).forEach((key)=> {
        pDataTSEM = [...pDataTSEM, {'time': predTSEM['prediction'][key].time, 'value': predTSEM['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataTSEM.length);
// TMD console.log(pDataTSEM);
ohlcDataMap = ohlcDataMap.set("TSEM", oDataTSEM);
predDataMap = predDataMap.set("TSEM", pDataTSEM);

let oDataWULF = [];
Object.keys(ohlcWULF.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataWULF = [...oDataWULF, ohlcWULF['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataWULF.length);
// TMD console.log(oDataWULF);

let pDataWULF = [];
Object.keys(predWULF.prediction).forEach((key)=> {
        pDataWULF = [...pDataWULF, {'time': predWULF['prediction'][key].time, 'value': predWULF['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataWULF.length);
// TMD console.log(pDataWULF);
ohlcDataMap = ohlcDataMap.set("WULF", oDataWULF);
predDataMap = predDataMap.set("WULF", pDataWULF);

let oDataFCEL = [];
Object.keys(ohlcFCEL.ohlc).forEach((key)=> {
        // console.log('key: ' + key);
        oDataFCEL = [...oDataFCEL, ohlcFCEL['ohlc'][key]];
});
// TMD console.log('OHLC_DATA ..... ' + oDataFCEL.length);
// TMD console.log(oDataFCEL);

let pDataFCEL = [];
Object.keys(predFCEL.prediction).forEach((key)=> {
        pDataFCEL = [...pDataFCEL, {'time': predFCEL['prediction'][key].time, 'value': predFCEL['prediction'][key].lgbm}];
});
// TMD console.log('PRED_DATA ..... ' + pDataFCEL.length);
// TMD console.log(pDataFCEL);
ohlcDataMap = ohlcDataMap.set("FCEL", oDataFCEL);
predDataMap = predDataMap.set("FCEL", pDataFCEL);


let pnlDataMap = I.Map();

    // TMD console.log(ohlcDataMap.keys());
    ohlcDataMap.forEach((ohlcDataArr, key) => {
        // TMD console.log(key);
        const predDataArr = predDataMap.get(key);
        const position = Math.floor(10000 / predDataArr[0].value);
        let explore_list = [];

        ohlcDataArr.forEach((ohlc) => {
            if ( (predDataArr[0].time <= ohlc.time) && (ohlc.time <= predDataArr[predDataArr.length-1].time))
            {
                const pred_value = InterpolateValue(predDataArr, ohlc.time);
                // TMD console.log( 'AI-ROBO-ADVISOR   ------- ' + key + ', ' + ohlc.time + ', ' + ohlc.high.toFixed(2) + ', ' + pred_value.toFixed(2) + ', ' + (ohlc.high - pred_value).toFixed(2) + ', ' + ((ohlc.high - pred_value) * 100 / ohlc.high).toFixed(2) + '%, ' + position + ', $' + (position * ohlc.high).toFixed(2) + ', ' + ((ohlc.high - predDataArr[0].value) * 100 / predDataArr[0].value).toFixed(2) + '%, '  + position + ', $' + (position * predDataArr[0].value).toFixed(2) + ', PnL: $' + (position * (ohlc.high - predDataArr[0].value)).toFixed(2));

                const row = {
                    'time': ohlc.time,
                    'timestamp': new Date(ohlc.time * 1000).toLocaleString(),
                    'ltp': ohlc.high.toFixed(2),
                    'pred': pred_value.toFixed(2),
                    'diff': (ohlc.high - pred_value).toFixed(2),
                    'diffpercent': ((ohlc.high - predDataArr[0].value) * 100 / ohlc.high).toFixed(2),
                    'position': position,
                    'buy': (position * predDataArr[0].value).toFixed(2),
                    'sell': (position * ohlc.high).toFixed(2),
                    'pnl': (position * (ohlc.high - predDataArr[0].value)).toFixed(2)
                };
                // TMD console.log(row);
                explore_list = [...explore_list, row];
            }
        });
        pnlDataMap = pnlDataMap.set(key, explore_list);
    });
        // TMD console.log(pnlDataMap);

export function InterpolateValue(
  points: {
    time: number;
    value: number;
  }[],
  t: number
): number | null {

    if ( points === undefined || points.length === 0)
    {
        return -1;
    }

    if (
        t < points[0].time ||
        t > points[points.length - 1].time
    ) {
        return -1;
    }

    for (
        let i = 0;
        i < points.length - 1;
        i++
    ) {

        const p1 = points[i];
        const p2 = points[i + 1];

        if (
            t >= p1.time &&
            t <= p2.time
        ) {

          const ratio =
            (t - p1.time) /
            (p2.time - p1.time);

          return (
            p1.value +
            ratio *
              (p2.value -
                p1.value)
          );
        }
    }

  return -1;
};

const initialState = {
  mapSWLPositive: new I.Map(), // (I.Map(): I.Map<string, TrendingPostion>),
  mapTrades: new I.Map(),
  mapMLForecast: new I.Map(),
  mapLastTrade: new I.Map(),
  ohlcDataMap: ohlcDataMap,
  predDataMap: predDataMap,
  pnlDataMap: pnlDataMap,
  mlforecast_req: {},
  mlforecast_loading: 0,
  ohlcInterval: "15",
  chartData: {
    "aud/usd": [
      [1605664235, 11060.1, 11499.0, 11060.1, 11301.5],
      [1605664335, 11299.4, 11443.9, 11262.0, 11376.6],
    ],
  },

  mobile_chart_opened: false,
  mobile_lite_order_ticket: false,
  

  /////////////////
  // SECOND CHART
  /////////////////
    mapSecondMLForecast: new I.Map(),
    second_mlforecast_req: {},
    second_mlforecast_loading: 0,
    ohlcIntervalSecond: "15",

  secondData: {
    "aud/usd": [
      [1605664235, 11060.1, 11499.0, 11060.1, 11301.5],
      [1605664335, 11299.4, 11443.9, 11262.0, 11376.6],
    ],
  },

  /////////////////
  // THIRD CHART
  /////////////////
    mapThirdMLForecast: new I.Map(),
    third_mlforecast_req: {},
    third_mlforecast_loading: 0,
    ohlcIntervalThird: "30",

  thirdData: {
    "aud/usd": [
      [1605664235, 11060.1, 11499.0, 11060.1, 11301.5],
      [1605664335, 11299.4, 11443.9, 11262.0, 11376.6],
    ],
  },
  /////////////////
  // FIRST CHART
  /////////////////
    mapFirstMLForecast: new I.Map(),
    first_mlforecast_req: {},
    first_mlforecast_loading: 0,
    ohlcIntervalFirst: "1",

  firstData: {
    "aud/usd": [
      [1605664235, 11060.1, 11499.0, 11060.1, 11301.5],
      [1605664335, 11299.4, 11443.9, 11262.0, 11376.6],
    ],
  },

  //////////////////
  // Historical MLP
  //////////////////
  mapPredictHistory: new I.Map(map_predict_history),
  mapPredict30History: new I.Map(),
  mapPredict15History: new I.Map(),
};

export class Trade {
  constructor(
    pair,
    trade_id,
    order_id,
    time_ms,
    trade_price,
    trade_qty,
    remain_qty,
    trade_cost,
    fee,
    is_buy
  ) {
    this.pair = pair;
    this.trade_id = trade_id;
    this.order_id = order_id;
    this.time_ms = time_ms;
    this.trade_price = trade_price;
    this.trade_qty = trade_qty;
    this.remain_qty = remain_qty;
    this.trade_cost = trade_cost;
    this.fee = fee;
    this.is_buy = is_buy;
  }
}

const chartReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.FETCH_MLFORECAST_REQUEST: {
        // TMD console.log("1. FETCH_MLFORECAST_REQUEST: " + action.payload);
        const loading = 1;
        return {
            ...state,
            mlforecast_req: action.payload,
            mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_SUCCESS: {
        // TMD console.log("2. FETCH_MLFORECAST_SUCCESS: ");
        // TMD console.log(action.payload);

        let iMap = state.mapMLForecast;
        let loading = 2;

        if ( (action.payload.data !== undefined) && 
             (action.payload.data.data !== undefined) && 
             (action.payload.data.data.result !== undefined) &&
             (action.payload.data.data.result.error === "none")
           )
        {
            // TMD console.log(action.payload.data.data.result.prediction);
            const predict = action.payload.data.data.result;
            iMap = iMap.set(predict.symbol, predict.prediction);
        } else {
            // TMD console.log( action.payload.data.data.result.error);
            loading = 3;
        }

        // TMD console.log(iMap);

        return {
            ...state,
            mlforecast_loading: loading,
            mapMLForecast: iMap,
        };
    }

    case actionTypes.FETCH_MLFORECAST_FAILURE: {
        // TMD console.log("3. FETCH_MLFORECAST_FAILURE: ");
        // TMD console.log(action.payload);
        const loading = 3;
        return {
            ...state,
            mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_RESET: {
        // TMD console.log("4. FETCH_MLFORECAST_RESET: ");
        const loading = 0;
        return {
            ...state,
            mlforecast_loading: loading,
        };
    }

    ///////////////////////////////
    // SECOND CHART START
    ///////////////////////////////

    case actionTypes.FETCH_MLFORECAST_REQUEST_SECOND: {
        // TMD console.log("1. FETCH_MLFORECAST_REQUEST_SECOND: " + action.payload);
        const loading = 1;
        return {
            ...state,
            second_mlforecast_req: action.payload,
            second_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_SUCCESS_SECOND: {
        // TMD console.log("2. FETCH_MLFORECAST_SUCCESS_SECOND: ");
        // TMD console.log(action.payload);

        let iMap = state.mapSecondMLForecast;
        let loading = 2;

        if ( (action.payload.data !== undefined) &&
             (action.payload.data.data !== undefined) &&
             (action.payload.data.data.result !== undefined) &&
             (action.payload.data.data.result.error === "none")
           )
        {
            // TMD console.log(action.payload.data.data.result.prediction);
            const predict = action.payload.data.data.result;
            iMap = iMap.set(predict.symbol, predict.prediction);
        } else {
            console.log( 'ERROR actionTypes.FETCH_MLFORECAST_SUCCESS_SECOND');
            console.log( action.payload);
            loading = 3;
        }

        // TMD console.log(iMap);

        return {
            ...state,
            second_mlforecast_loading: loading,
            mapSecondMLForecast: iMap,
        };
    }

    case actionTypes.FETCH_MLFORECAST_FAILURE_SECOND: {
        // TMD console.log("3. FETCH_MLFORECAST_FAILURE_SECOND: ");
        // TMD console.log(action.payload);
        const loading = 3;
        return {
            ...state,
            second_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_RESET_SECOND: {
        // TMD console.log("4. FETCH_MLFORECAST_RESET_SECOND: ");
        const loading = 0;
        return {
            ...state,
            second_mlforecast_loading: loading,
        };
    }

    case actionTypes.SECOND_OHLC_INTERVAL: {
      return {
        ...state,
        ohlcIntervalSecond: action.payload.ohlcInterval,
      };
    }

    case actionTypes.SECOND_OHLC: {
      const payload = action.payload;


      let currentChartData = { ...state.secondData };
      let mapHistory = { ...state.mapPredict15History };

      if ( (payload.pair !== undefined) && (payload.ohlc !== undefined))
      {
            console.log( 'SAMEER -------------- SECOND_OHLC - payload.{}------------- ' + payload.pair + ', ' + payload.ohlc.length);
            currentChartData[payload.pair] = payload.ohlc;

      } else if ( (payload.data.pair !== undefined) && (payload.data.ohlc !== undefined)) {

            console.log( 'SAMEER -------------- SECOND_OHLC payload.data.{} -------------- ' + payload.data.pair + ', ' + payload.data.ohlc.length);
            currentChartData[payload.data.pair] = payload.data.ohlc;
            mapHistory[payload.data.pair] =  payload.data.ohlc[payload.data.ohlc.length-1];
      }

      // TMD console.log(currentChartData);
      // TMD console.log( mapHistory);

      return {
        ...state,
        secondData: currentChartData,
        mapPredict15History: mapHistory,
      };
    }

    ///////////////////////////////
    // SECOND CHART END
    ///////////////////////////////

    ///////////////////////////////
    // THIRD CHART START
    ///////////////////////////////

    case actionTypes.FETCH_MLFORECAST_REQUEST_THIRD: {
        // TMD console.log("1. FETCH_MLFORECAST_REQUEST_THIRD: " + action.payload);
        const loading = 1;
        return {
            ...state,
            third_mlforecast_req: action.payload,
            third_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_SUCCESS_THIRD: {
        // TMD console.log("2. FETCH_MLFORECAST_SUCCESS_THIRD: ");

        let iMap = state.mapThirdMLForecast;
        let loading = 2;

        if ( (action.payload.data !== undefined) &&
             (action.payload.data.data !== undefined) &&
             (action.payload.data.data.result !== undefined) &&
             (action.payload.data.data.result.error === "none")
           )
        {
            // TMD console.log(action.payload.data.data.result.prediction);
            const predict = action.payload.data.data.result;
            iMap = iMap.set(predict.symbol, predict.prediction);
        } else {
            console.log( 'ERROR actionTypes.FETCH_MLFORECAST_SUCCESS_THIRD');
            console.log( action.payload);
            loading = 3;
        }

        // TMD console.log(iMap);

        return {
            ...state,
            third_mlforecast_loading: loading,
            mapThirdMLForecast: iMap,
        };
    }

    case actionTypes.FETCH_MLFORECAST_FAILURE_THIRD: {
        // TMD console.log("3. FETCH_MLFORECAST_FAILURE_THIRD: ");
        // TMD console.log(action.payload);
        const loading = 3;
        return {
            ...state,
            third_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_RESET_THIRD: {
        // TMD console.log("4. FETCH_MLFORECAST_RESET_THIRD: ");
        const loading = 0;
        return {
            ...state,
            third_mlforecast_loading: loading,
        };
    }

    case actionTypes.THIRD_OHLC_INTERVAL: {
      return {
        ...state,
        ohlcIntervalThird: action.payload.ohlcInterval,
      };
    }

    case actionTypes.THIRD_OHLC: {
      const payload = action.payload;


      let currentChartData = { ...state.thirdData };
      let mapHistory = { ...state.mapPredict30History };

      if ( (payload.pair !== undefined) && (payload.ohlc !== undefined))
      {
            // TMD console.log( 'SAMEER -------------- THIRD_OHLC - payload.{}------------- ' + payload.pair + ', ' + payload.ohlc.length);
            currentChartData[payload.pair] = payload.ohlc;

      } else if ( (payload.data.pair !== undefined) && (payload.data.ohlc !== undefined)) {

            // TMD console.log( 'SAMEER -------------- THIRD_OHLC payload.data.{} -------------- ' + payload.data.pair + ', ' + payload.data.ohlc.length);
            currentChartData[payload.data.pair] = payload.data.ohlc;
            mapHistory[payload.data.pair] =  payload.data.ohlc[payload.data.ohlc.length-1];
      }

      // TMD console.log(currentChartData);
      // TMD console.log( mapHistory);

      return {
        ...state,
        thirdData: currentChartData,
        mapPredict30History: mapHistory,
      };
    }

    ///////////////////////////////
    // THIRD CHART END
    ///////////////////////////////

    ///////////////////////////////
    // FIRST CHART START
    ///////////////////////////////

    case actionTypes.FETCH_MLFORECAST_REQUEST_FIRST: {
        // TMD console.log("1. FETCH_MLFORECAST_REQUEST_FIRST: " + action.payload);
        const loading = 1;
        return {
            ...state,
            first_mlforecast_req: action.payload,
            first_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_SUCCESS_FIRST: {
        // TMD console.log("2. FETCH_MLFORECAST_SUCCESS_FIRST: ");
        // TMD console.log(action.payload);

        let iMap = state.mapFirstMLForecast;
        let loading = 2;

        if ( (action.payload.data !== undefined) &&
             (action.payload.data.data !== undefined) &&
             (action.payload.data.data.result !== undefined) &&
             (action.payload.data.data.result.error === "none")
           )
        {
            const predict = action.payload.data.data.result;
            iMap = iMap.set(predict.symbol, predict.prediction);
        } else {
            // TMD console.log( action.payload.data.data.result.error);
            loading = 3;
        }

        // TMD console.log(iMap);

        return {
            ...state,
            first_mlforecast_loading: loading,
            mapFirstMLForecast: iMap,
        };
    }

    case actionTypes.FETCH_MLFORECAST_FAILURE_FIRST: {
        // TMD console.log("3. FETCH_MLFORECAST_FAILURE_FIRST: ");
        // TMD console.log(action.payload);
        const loading = 3;
        return {
            ...state,
            first_mlforecast_loading: loading,
        };
    }

    case actionTypes.FETCH_MLFORECAST_RESET_FIRST: {
        // TMD console.log("4. FETCH_MLFORECAST_RESET_FIRST: ");
        const loading = 0;
        return {
            ...state,
            first_mlforecast_loading: loading,
        };
    }

    case actionTypes.FIRST_OHLC_INTERVAL: {
      return {
        ...state,
        ohlcIntervalFirst: action.payload.ohlcInterval,
      };
    }

    /*******
    case actionTypes.FIRST_OHLC: {
      const payload = action.payload;


      let currentChartData = { ...state.firstData };
      let mapHistory = { ...state.mapPredict30History };

      if ( (payload.pair !== undefined) && (payload.ohlc !== undefined))
      {
            // TMD console.log( 'SAMEER -------------- FIRST_OHLC - payload.{}------------- ' + payload.pair + ', ' + payload.ohlc.length);
            currentChartData[payload.pair] = payload.ohlc;

      } else if ( (payload.data.pair !== undefined) && (payload.data.ohlc !== undefined)) {

            // TMD console.log( 'SAMEER -------------- FIRST_OHLC payload.data.{} -------------- ' + payload.data.pair + ', ' + payload.data.ohlc.length);
            currentChartData[payload.data.pair] = payload.data.ohlc;
            mapHistory[payload.data.pair] =  payload.data.ohlc[payload.data.ohlc.length-1];
      }

      // TMD console.log(currentChartData);
      // TMD console.log( mapHistory);

      return {
        ...state,
        firstData: currentChartData,
        mapPredict30History: mapHistory,
      };
    }
    ******/

    ///////////////////////////////
    // FIRST CHART END
    ///////////////////////////////

    case actionTypes.MOBILE_CHART_OPENED: {
      return {
        ...state,
        mobile_chart_opened: action.payload.is_mobile_chart_opened,
      };
    }

    case actionTypes.MOBILE_LITE_ORDER_TICKET: {
      return {
        ...state,
        mobile_lite_order_ticket: action.payload.is_mobile_lite_order_ticket,
      };
    }

    case actionTypes.KRAKEN_OHLC_INTERVAL: {
      return {
        ...state,
        ohlcInterval: action.payload.ohlcInterval,
      };
    }

    case actionTypes.OHLC_NOTIFY_CHART: {

        // TMD console.log( 'OHLC_NOTIFY ---- CHART');
        // TMD console.log( action.payload);

        let chartData = { ...state.chartData };
        let secondData = { ...state.secondData };
        let thirdData = { ...state.thirdData };

        // TMD console.log( action.payload.data.query.symbol);

        if ( (action.payload !== undefined) && (action.payload.data !== undefined) && (action.payload.data.query !== undefined))
        {
            const query = action.payload.data.query;

            // TMD console.log( 'OHLC_NOTIFY ---> ' + query.symbol + ', ' + query.symbol.includes("-60"));
            // TMD console.log( 'OHLC_NOTIFY ---> ' + query.symbol + ', ' + query.symbol.includes("-15"));
            // TMD console.log( 'OHLC_NOTIFY ---> ' + query.symbol + ', ' + query.symbol.includes("-5"));

            const ohlc = {
                "time": (Date.parse(query.ohlcv[0].t)/1000),
                "open": query.ohlcv[0].o,
                "high": query.ohlcv[0].h,
                "low": query.ohlcv[0].l,
                "close": query.ohlcv[0].c,
            };

            const lsymbol = query.symbol.substring(0, query.symbol.indexOf('-'));
            if ( query.symbol.includes("-30") === true)
            {
                // TMD console.log( 'ADDING OHLC to CHART::chartData[ ' + query.symbol + ' ]');
                if (thirdData[lsymbol] !== undefined) {
                    thirdData[lsymbol] = [ ...thirdData[lsymbol], ohlc];
                }
            }
            else if (query.symbol.includes("-15") === true)
            {
                // TMD console.log( 'ADDING OHLC to CHART::chartData[ ' + query.symbol + ' ]');
                if (secondData[lsymbol] !== undefined) {
                    secondData[lsymbol] = [ ...secondData[lsymbol], ohlc];
                }
            }
            else if (query.symbol.includes("-60") === true)
            {
                // TMD console.log( 'ADDING OHLC to CHART::chartData[ ' + query.symbol + ' ]');
                if (chartData[lsymbol] !== undefined) {
                    chartData[lsymbol] = [ ...chartData[lsymbol], ohlc];
                }
            }
        }

        return {
            ...state,
            chartData: chartData,
            secondData: secondData,
            thirdData: thirdData,
        }
    }

    /**
    case actionTypes.SWL_NOTIFY_CHART: {
      // !!! TEMPORARRY SKIP LIVE CHART DATA !!!
      // return state;



      const payload = action.payload.data;
      // TMD console.log( {payload});
      const adjust_epoch = 6 * 3600; // 60 min in millisec

      if ( payload.data[0].ohlc.time === 0)
      {
        // TMD console.log( "chartReducer returning... === 0");
        // TMD console.log( payload.data[0]);
        return {...state};
      }
        // TMD console.log( "chartReducer Consuming");
        // TMD console.log( payload.data[0].ohlc);

      let currentChartData = { ...state.chartData };

      // TMD console.log( payload.data[0]);
      const ohlc = {
        "time": payload.data[0].ohlc.time,
        "open": payload.data[0].ohlc.open,
        "high": payload.data[0].ohlc.high,
        "low": payload.data[0].ohlc.low,
        "close": payload.data[0].ohlc.close,
      };

      if (currentChartData[payload.data[0].symbol]) {
          currentChartData[payload.data[0].symbol] = [
            ...currentChartData[payload.data[0].symbol],
            ohlc,
          ];

      } else {
        currentChartData[payload.data[0].symbol] = [ohlc];
      }

      // TMD console.log( {currentChartData});
      return {
        ...state,
        chartData: currentChartData,
      };
    }
    */

    case actionTypes.SET_LAST_TRADE: {
      let iMap = state.mapLastTrade;
      iMap = iMap.set(action.payload.coin, action.payload.trade);

      return {
        ...state,
        mapLastTrade: iMap,
      };
    }

    case actionTypes.FETCH_TRADES: {
      //HERE we set all  orders in charts.
      return state;

      let iMap = state.mapTrades;
      action.payload.data.trades.forEach((t, index) => {
        let trade = new Trade(
          t.pair,
          t.trade_id,
          t.order_id,
          t.time_ms,
          t.trade_price,
          t.trade_qty,
          t.remain_qty,
          t.trade_cost,
          t.fee,
          t.is_buy
        );
        iMap = iMap.set(trade.trade_id, trade);
      });

      return {
        ...state,
        mapTrades: iMap,
      };
    }

    case actionTypes.KRAKEN_OHLC: {
      const payload = action.payload;


      let currentChartData = { ...state.chartData };

      if ( (payload.pair !== undefined) && (payload.ohlc !== undefined))
      {
            // TMD console.log( 'SAMEER -------------- KRAKEN_OHLC - payload.{}------------- ' + payload.pair + ', ' + payload.ohlc.length);
            currentChartData[payload.pair] = payload.ohlc;

      } else if ( (payload.data.pair !== undefined) && (payload.data.ohlc !== undefined)) {

            // TMD console.log( 'SAMEER -------------- KRAKEN_OHLC payload.data.{} -------------- ' + payload.data.pair + ', ' + payload.data.ohlc.length);
            currentChartData[payload.data.pair] = payload.data.ohlc;
      }

      // TMD console.log(currentChartData);

      return {
        ...state,
        chartData: currentChartData,
      };
    }

    case actionTypes.TRADES_TABLE: {
      let mapOrders = state.mapOrders;
      if (mapOrders === undefined) {
        mapOrders = I.Map();
      }

      map_coins.forEach((value, key) => {
        const mapListOrders = action.payload
          .filter(
            (orderList) =>
              orderList.coin === key &&
              !orderList.data.some((order) => order.orderStatus === 6)
          )
          .map((item) => item.data[item.data.length - 1]);
        if (key !== undefined && mapListOrders !== undefined) {
          mapOrders = mapOrders.set(key, mapListOrders);
        }
      });
      // console.log("reducer: TRADES_TABLE mapOrders");
      // console.log(mapOrders);

      return {
        ...state,
        tradesTable: action.payload,
        mapOrders: mapOrders,
      };
    }

    default:
      return state;
  }
};

export default chartReducer;
